import { render, staticRenderFns } from "./primary-contact.vue?vue&type=template&id=5c5891ea&scoped=true&"
import script from "./primary-contact.vue?vue&type=script&lang=js&"
export * from "./primary-contact.vue?vue&type=script&lang=js&"
import style0 from "./primary-contact.vue?vue&type=style&index=0&id=5c5891ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5891ea",
  null
  
)

export default component.exports